import React from "react";
import SortVisualizer from "./SortVisualizer/SortVisualizer";

function App() {
  return <SortVisualizer></SortVisualizer>;
}

export default App;
